import React, { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useAdminStore } from '../../stores/useAdminStore';
import { useSeasonsStore } from '../../stores/useSeasonsStore';
import { PhotoUpload } from './PhotoUpload';
import { BaseModal } from '../shared/Modal/BaseModal';
import './PhotoUploadModal.css';

export const PhotoUploadModal: React.FC = () => {
  const { showUploadModal, selectedEventForUpload, closeUploadModal } = useAdminStore(
    useShallow(s => ({
      showUploadModal: s.showUploadModal,
      selectedEventForUpload: s.selectedEventForUpload,
      closeUploadModal: s.closeUploadModal,
    }))
  );
  const { photosByEvent } = useSeasonsStore();

  const eventData = selectedEventForUpload ? photosByEvent[selectedEventForUpload] : null;

  useEffect(() => {
    if (showUploadModal && selectedEventForUpload && !eventData) {
      console.error('Event not found in photosByEvent:', selectedEventForUpload);
      console.error('Available events:', Object.keys(photosByEvent));
      closeUploadModal();
    }
  }, [showUploadModal, selectedEventForUpload, eventData, photosByEvent, closeUploadModal]);

  if (!showUploadModal || !eventData) {
    return null;
  }

  return (
    <BaseModal
      isOpen={showUploadModal}
      onClose={closeUploadModal}
      title={`Add Photos to ${eventData.event.name}`}
      className="upload-modal-content"
      data-testid="photo-upload-modal"
    >
      <PhotoUpload
        eventName={eventData.event.name}
        month={eventData.event.month}
        seasonId={eventData.season}
      />
    </BaseModal>
  );
};
